import { render, staticRenderFns } from "./ContractAdmistration.vue?vue&type=template&id=08d780ba"
import script from "./ContractAdmistration.vue?vue&type=script&lang=js"
export * from "./ContractAdmistration.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports